import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=137063d8&scoped=true&"
import script from "./QrCode.vue?vue&type=script&lang=js&"
export * from "./QrCode.vue?vue&type=script&lang=js&"
import style0 from "./QrCode.vue?vue&type=style&index=0&id=137063d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137063d8",
  null
  
)

export default component.exports